import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Axios } from '../../api';
import { setIsCephUser } from '../../redux/slices/userSlice';
import Loading from '../Loading';

const BaseApi = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const dispatch = useDispatch();

    const getIsCephUser = async () => {
        try {
            const result = await Axios.get("api/cephalometrics/is-ceph-user");
            dispatch(setIsCephUser(result.data.payload.is_ceph_user));
        } catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getIsCephUser();
    }, []);

    return (
        loading && !error ?
            <Loading />
            : !loading && error ?
                <div>
                    <h1>Something went wrong</h1>
                </div>
                : !loading && !error ? children : null
    );
};

export default BaseApi;